import MapView from '../components/Map/MapView';

const Home = () => {

  return (
    <>
      <MapView />
    </>
  );
};

export default Home;
